import { useState, useEffect } from "react";

/**
 * Detects the visitor's country via the /api/geo backend endpoint.
 *
 * - Returns { country: null, loading: true } on the first render so callers
 *   can show a skeleton instead of the wrong country's content.
 * - Caches the result in sessionStorage so repeat visits are instant (no
 *   skeleton, no extra network request).
 * - Falls back to "IN" silently on any network / API error.
 */
export function useGeo() {
    const [country, setCountry] = useState(null); // null = not yet resolved

    useEffect(() => {
        const cached = sessionStorage.getItem("userCountry");
        if (cached) {
            console.log("[useGeo] ✅ Country loaded from sessionStorage cache:", cached);
            setCountry(cached);
            return;
        }

        console.log("[useGeo] 🌍 Fetching country from /api/geo ...");
        fetch("/api/geo")
            .then((res) => {
                console.log("[useGeo] 📡 /api/geo response status:", res.status);
                return res.json();
            })
            .then((data) => {
                console.log("[useGeo] 📦 /api/geo response data:", data);
                const c = data.country || "IN";
                console.log("[useGeo] 🗺️ Resolved country code:", c);
                setCountry(c);
                sessionStorage.setItem("userCountry", c);
            })
            .catch((err) => {
                console.warn("[useGeo] ⚠️ /api/geo failed, falling back to IN:", err);
                setCountry("IN");
            });
    }, []);

    return { country, loading: country === null };
}
